var map = {
	"./ContactsView.vue": 3860,
	"./HelpView.vue": 4444,
	"./HomeView.vue": 1537,
	"./PrivacyView.vue": 4791,
	"./TermsView.vue": 6756,
	"./ThemesView.vue": 9128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 425;